import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AppButton, Reveal } from '@/components/atoms';
import { Section } from '@/components/organisms';
import { introVehicles } from '@/config/introVehicles';

import { handover as copy, HANDOVER_TITLE_ID, handoverStages } from '../content';
import { HandoverStageRow } from '../molecules';

/**
 * The last stage of the import, as a sequence.
 *
 * The three stages are ordered — package services are completed, the customer
 * is updated, then the vehicle is handed over — and the three equal tiles this
 * replaces gave that order no expression at all. A timeline
 * reads as a schedule, which is what a visitor asking "what happens when my
 * car arrives" is actually asking for.
 *
 * No hook: the three stages are fixed copy and nothing on the band thinks.
 */
export function HandoverTimeline() {
  return (
    <Section
      tone="muted"
      pattern="grid"
      labelledBy={HANDOVER_TITLE_ID}
      backdrop={{ picture: introVehicles.hilux.image, placement: 'right' }}
    >
      <Grid container spacing={{ xs: 8, md: 12 }}>
        <Grid size={{ xs: 12, md: 5 }}>
          <Box sx={{ position: { md: 'sticky' }, top: { md: 120 } }}>
            <Reveal direction="left">
              <Stack spacing={5} alignItems="flex-start">
                <Typography variant="overline" sx={{ color: 'primary.main' }}>
                  {copy.eyebrow}
                </Typography>
                <Typography id={HANDOVER_TITLE_ID} variant="h2" component="h2">
                  {copy.title}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {copy.lede}
                </Typography>
                <AppButton to="/how-it-works" appVariant="secondary">
                  See the whole process
                </AppButton>
              </Stack>
            </Reveal>
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 7 }}>
          <Stack
            component="ol"
            aria-labelledby={HANDOVER_TITLE_ID}
            sx={{ listStyle: 'none', p: 0, m: 0 }}
          >
            {handoverStages.map((stage, index) => (
              <HandoverStageRow
                key={stage.title}
                stage={stage}
                position={index + 1}
                last={index === handoverStages.length - 1}
              />
            ))}
          </Stack>
        </Grid>
      </Grid>
    </Section>
  );
}
